var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"import-area bg-input",attrs:{"placeholder":_vm.$t('components.fleet.import')},on:{"input":function($event){return _vm.onImport($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }